export default __webpack_public_path__ + "e61e12e1a0e304ff99f62388eca2b16c.webp";